import { removeSectionKeepItemsOptimistically } from '../utils/quote-helpers';
import { useQuoteMutation } from './create-quote-mutation';

/**
 * Remove section from quote but keep its items at the root level
 * Items are moved to where the section was located
 * Uses optimistic updates for immediate UI feedback
 */
export const useRemoveSectionKeepItems = (quoteId: string) =>
  useQuoteMutation<string>({
    quoteId,
    optimisticUpdate: removeSectionKeepItemsOptimistically
  });
